import axiosInstance from '../../axiosInstance';

const setAthletePreferredSection = async ({
  playerId = 'none',
  preferredHomeSection = '',
}) => {
  const response = await axiosInstance.patch(
    `/api/admin/v2/players/${playerId}/preferred-home-section`,
    {
      preferred_home_section: preferredHomeSection,
    },
  );

  const { data } = response.data;
  return data;
};

export default setAthletePreferredSection;
